import { render, staticRenderFns } from "./PaymentsHasTrouble.vue?vue&type=template&id=47a4468c&scoped=true"
import script from "./PaymentsHasTrouble.vue?vue&type=script&lang=js"
export * from "./PaymentsHasTrouble.vue?vue&type=script&lang=js"
import style0 from "./PaymentsHasTrouble.vue?vue&type=style&index=0&id=47a4468c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a4468c",
  null
  
)

export default component.exports